import { Button, ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import React from 'react';
import { Session } from '../../../utils';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';

interface Props {
    sessions: Session[];
    selectedSessions: Session[];
    onChange: (sessions: Session[]) => void;
}

function GroupSessionsList({ sessions, selectedSessions, onChange }: Props): React.ReactElement {
    const theme = useTheme();

    function onSelect(session: Session) {
        const selected = [...selectedSessions];

        const ix = selected.findIndex((s) => s.uuid === session.uuid);

        if (ix > -1) {
            selected.splice(ix, 1);
        } else {
            selected.push(session);
        }

        onChange(selected);
    }

    function renderItem(props: any) {
        const s = sessions[props.index];
        return (
            <ListItem button key={props.index} style={props.style} onClick={() => onSelect(s)}>
                <ListItemIcon style={{ marginRight: 10 }}>
                    {selectedSessions.findIndex((sess) => sess.uuid === s.uuid) > -1 ? (
                        <Button variant="contained" size={'small'} color="primary">
                            <CheckCircleOutlineIcon
                                style={{ color: theme.palette.secondary.main }}
                            />
                            &nbsp; Shared
                        </Button>
                    ) : (
                        <Button size={'small'}>
                            <RadioButtonUncheckedIcon />
                            &nbsp; Share
                        </Button>
                    )}
                </ListItemIcon>
                {selectedSessions.findIndex((sess) => sess.uuid === s.uuid) > -1 ? (
                    <ListItemText primary={s.title} />
                ) : (
                    <ListItemText secondary={s.title} />
                )}
            </ListItem>
        );
    }

    return (
        <AutoSizer>
            {({ width, height }: { width: number; height: number }) => (
                <FixedSizeList
                    height={height}
                    width={width}
                    itemSize={48}
                    itemCount={sessions.length}
                >
                    {renderItem}
                </FixedSizeList>
            )}
        </AutoSizer>
    );
}

export default GroupSessionsList;
